export const APPLICATION_URL = 'https://tally.so/r/EkpjyA';
export const SHIFT_AI_URL = 'https://www.shiftthework.ai/';
export const AI_BOOST_DEMO_FORM_URL = 'https://tally.so/r/PdoMyV';
export const CONSULTING_FORM_URL = 'https://tally.so/r/GxMNyZ';
export const ACCELERATOR_EXPLORE_FORM_URL = 'https://tally.so/r/VLrRyg';
export const ACCELERATOR_APPLICATION_FORM_URL = 'https://tally.so/r/EkpjyA';